<div class="months-page">
  <h1>Edit months</h1>

  @if (loading()) {
    <stena-skeleton-loader type="text" [rows]="3" />
  } @else {
    <form [formGroup]="form" class="controls">
      <stena-select
        class="dense-3"
        formControlName="mode"
        label="Mode"
        [options]="modeOptions"
      />
      <stena-select
        class="dense-3"
        formControlName="startMonthId"
        label="Start month"
        [options]="monthSelectOptions()"
      />
      <stena-select
        class="dense-3"
        formControlName="endMonthId"
        label="End month"
        [options]="monthSelectOptions()"
      />
      <stena-button
        type="raised"
        color="primary"
        text="Save"
        [disabled]="saving()"
        (buttonClick)="onSave()"
      />
    </form>

    <p class="current-period">{{ currentPeriodLabel() }}</p>

    <section class="fiscal-year">
      <stena-button
        type="stroked"
        text="Create next fiscal year (12 months)"
        [disabled]="saving()"
        (buttonClick)="onCreateFiscalYear()"
      />
    </section>
  }
</div>
